import { render, staticRenderFns } from "./DynamicLoader.vue?vue&type=template&id=6d499570"
import script from "./DynamicLoader.vue?vue&type=script&lang=js"
export * from "./DynamicLoader.vue?vue&type=script&lang=js"
import style0 from "./DynamicLoader.vue?vue&type=style&index=0&id=6d499570&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports